// extracted by mini-css-extract-plugin
module.exports = {"container":"ManualAddressForm_container__QYLsZ","container_row":"ManualAddressForm_container_row__15Rci","latlong_text":"ManualAddressForm_latlong_text__2xC2l"};